import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fieldsList", "error"];

  static values = {
    containerSelector: { type: String, default: "[data-sortable-fields-container]" },
    frameId: { type: String, default: "" },
    persistOnDrop: { type: Boolean, default: false }
  }

  connect() {
    $.uf.maxLength(this.element, "textarea");
    this.initializeSortable();
    this.listenForFieldAddition();
    document.addEventListener("turbo:load", this.initializeSortable.bind(this));
    document.addEventListener("turbo:before-stream-render", this.initializeSortable.bind(this));
    this.setupCollapseListeners();
    this.observeMutations();
    this.listenForSaveResult();
  }

  listenForSaveResult() {
    if (!this.hasErrorTarget) return;

    $(this.element).on("ajax:success", () => this.errorTarget.classList.add("hidden"));
    $(this.element).on("ajax:error", () => this.errorTarget.classList.remove("hidden"));
  }

  setupCollapseListeners() {
    const observer = new MutationObserver((mutations) => {
      this.processMutations(mutations);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    this.addCollapseListeners();
  }

  processMutations(mutations) {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        this.addCollapseListeners();
      }
    });
  }

  addCollapseListeners() {
    const toggleLinks = document.querySelectorAll("[id^='toggle-link-']");
    toggleLinks.forEach((toggleLink) => {
      // Prevent re-adding listeners to the same element
      if (toggleLink.dataset.listenerAdded) {
        return;
      }

      const target = document.querySelector(toggleLink.getAttribute("href"));
      if (target) {
        $(target).on("shown.bs.collapse", function () {
          toggleLink.textContent = window.I18n["general.hide"];
        });

        $(target).on("hidden.bs.collapse", function () {
          toggleLink.textContent = window.I18n["general.options"];
        });

        // Check initial state
        if (target.classList.contains("in") || target.classList.contains("show")) {
          toggleLink.textContent = window.I18n["general.hide"];
        } else {
          toggleLink.textContent = window.I18n["general.options"];
        }
      }

      // Mark this element as processed
      toggleLink.dataset.listenerAdded = true;
    });
  }

  listenForFieldAddition() {
    var controlTypeSelect = document.getElementById("control_type_select");
    if (controlTypeSelect) {
      controlTypeSelect.addEventListener("change", function () {
        var selectedControlType = this.value;
        var link = document.getElementById("link_" + selectedControlType);
        if (link) {
          link.click();
          this.value = "";
        }
      });
    }
  }

  initializeSortable() {
    $(this.fieldsListTarget).sortable({
      update: (event, ui) => {
        this.updateIndex();
      }
    });
  }

  updateIndex() {
    const items = this.fieldsListTarget.querySelectorAll(".fields");
    items.forEach((element, index) => {
      const hiddenField = element.querySelector("input[name*='[order]']");
      if (hiddenField) {
        hiddenField.value = index;
      }
    });

    if (this.persistOnDropValue) {
      const form = this.element.closest("form");
      if (form) form.requestSubmit();
    }
  }

  observeMutations() {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          this.handleChildListMutation();
        }
      }
    });
    observer.observe(this.fieldsListTarget, { childList: true, subtree: true });
  }

  handleChildListMutation() {
    this.initializeSortable();
    this.updateLastDivOrder();

    const items = this.fieldsListTarget.querySelectorAll(".fields");
    items.forEach((element, index) => {
      const hiddenField = element.querySelector("input[name*='[order]']");
      if (hiddenField) {
        hiddenField.value = index;
      }
    });
  }

  updateLastDivOrder() {
    const frameId = this.frameIdValue || this.fieldsListTarget.id;
    const turboFrame = document.querySelector(`#${frameId}`);

    if (turboFrame) {
      let divCount = turboFrame.querySelectorAll("div.form-group.row").length;
      const lastDiv = turboFrame.querySelector("div.form-group.row:last-child");
      if (lastDiv) {
        const input = lastDiv.querySelector("input[name*='[order]']");
        if (input) {
          input.value = divCount - 1;
        }
      }
    }
  }
}